import { useQuery } from 'react-query';
import { axiosRequestHandler } from 'helpers/Requests';
import { IMetadataResponse } from 'interfaces/pages';

export function useMetaData() {
  const queryKey: string = '/platform/api/v1/shoppingtools/metadata';
  return useQuery<IMetadataResponse, Error>(
    queryKey,
    async () => {
      const response = await axiosRequestHandler(queryKey);
      return response.data as IMetadataResponse;
    },
    {
      staleTime: Infinity,
    }
  );
}
